import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IUserChild } from '@kcftech/prometheustypescriptapiclient';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { InfoPopup } from 'components/popup/InfoPopup';
import {
    ActionsColumn,
    EmailColumn,
    FirstNameColumn,
    LastNameColumn,
    UsersListItem,
} from 'components/users/styled';
import { isKcfUser } from 'pages/Desk/issues/shared';
import * as React from 'react';
import { KCFColor } from 'styles/themes/KCFColor';

export type UsersListViewItemProps = Readonly<{
    user: IUserChild & { error?: string };
    color: string;
    onDelete?: () => void;
    disabled?: boolean;
}>;

export function UsersList({ user, color, onDelete, disabled }: UsersListViewItemProps) {
    const onClickDeleteButton = (
        event: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>
    ) => {
        event.preventDefault();
        if (onDelete) {
            onDelete();
        }
    };

    return (
        <UsersListItem $color={color}>
            <FirstNameColumn title={user.UserFirstName} className="ellipsis-1-line">
                {user.UserFirstName}
            </FirstNameColumn>
            <LastNameColumn title={user.UserLastName} className="ellipsis-1-line">
                {user.UserLastName}
            </LastNameColumn>
            <EmailColumn title={user.UserEmail} className="ellipsis-1-line">
                {user.UserEmail}
                {isKcfUser(user.UserApplicationRole) && (
                    <FontAwesomeIcon icon={faShieldHalved} className="ml-10" />
                )}
            </EmailColumn>
            <ActionsColumn>
                {user.error !== undefined && (
                    <InfoPopup title="User" type="error">
                        {user.error}
                    </InfoPopup>
                )}
                {onDelete && !disabled && (
                    <HoverIconButton
                        icon={faTimes}
                        hoverIcon={faTimes}
                        color={KCFColor.mediumGrey6}
                        onClick={onClickDeleteButton}
                        aria-label="Clear selection"
                        className="f-15"
                        title="Clear selection"
                    />
                )}
            </ActionsColumn>
        </UsersListItem>
    );
}
